<div *ngIf="isPageReady" class="flex flex-col h-full">
  <div class="qb-content-card flex-1">
    <div class="qb-detail-card w-full h-fit">
      <div class="flex flex-col gap-3">
        <!-- Dynamic fields -->
        <ng-container *ngFor="let fieldName of this.fieldNames; let i = index; let first = first">
          <div class="grid grid-cols-12 gap-3">
            <qb-field [label]="this.fieldLabels[i]" class="col-span-12">
              <input #firstInput *ngIf="first" pInputText [(ngModel)]="target[fieldName]" [bzModel]="target" [name]="fieldName" [title]="this.fieldLabels[i]" />
              <input *ngIf="!first" pInputText [(ngModel)]="target[fieldName]" [bzModel]="target" [name]="fieldName" [title]="this.fieldLabels[i]" />
            </qb-field>
          </div>
        </ng-container>

        <!-- Status field (if entity has activeStatusId) -->
        <div class="grid grid-cols-12 gap-3" *ngIf="target['activeStatusId']">
          <qb-field label="Status" class="col-span-6">
            <p-dropdown
              [(ngModel)]="target['activeStatusId']"
              [bzModel]="target"
              name="activeStatusId"
              [options]="activeStatuses"
              optionValue="id"
              optionLabel="name"
            />
          </qb-field>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-row gap-2 justify-start mt-4">
    <button [disabled]="!this.dbQueryService.uow.hasChanges()" (click)="ok()" pButton type="button" label="Ok" title="Ok" icon="pi pi-check" class="p-button-raised"></button>
    <button (click)="cancel()" pButton type="button" label="Cancel" title="Cancel" icon="pi pi-times" class="p-button-raised"></button>
  </div>
</div>
